import React from 'react';
import { Mail, Phone, MapPin, Building, Globe, UserPlus } from 'lucide-react';

const EnseignantExterneDetails = ({ enseignant }) => {
  if (!enseignant) return null;

  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-4">
        <div className="bg-gray-100 p-3 rounded-lg">
          <UserPlus className="h-8 w-8 text-gray-600" />
        </div>
        <div>
          <h3 className="text-xl font-semibold text-gray-900">
            {enseignant.nom_complet}
          </h3>
          <span className="inline-block px-3 py-1 text-sm font-medium bg-gray-100 text-gray-700 rounded-full">
            {enseignant.titre}
          </span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-4">
          <h4 className="font-medium text-gray-900">Informations personnelles</h4>
          
          {enseignant.utilisateur?.email && (
            <div className="flex items-center space-x-3">
              <Mail className="h-5 w-5 text-gray-500" />
              <span className="text-gray-600">{enseignant.utilisateur.email}</span>
            </div>
          )}

          {enseignant.telephone && (
            <div className="flex items-center space-x-3">
              <Phone className="h-5 w-5 text-gray-500" />
              <span className="text-gray-600">{enseignant.telephone}</span>
            </div>
          )}

          {enseignant.adresse && (
            <div className="flex items-start space-x-3">
              <MapPin className="h-5 w-5 text-gray-500 mt-0.5" />
              <span className="text-gray-600">{enseignant.adresse}</span>
            </div>
          )}
        </div>

        <div className="space-y-4">
          <h4 className="font-medium text-gray-900">Informations professionnelles</h4>
          
          <div className="flex items-center space-x-3">
            <Building className="h-5 w-5 text-gray-500" />
            <span className="text-gray-600">{enseignant.etablissement_origine}</span>
          </div>

          <div className="flex items-center space-x-3">
            <Globe className="h-5 w-5 text-gray-500" />
            <span className="text-gray-600">{enseignant.specialite}</span>
          </div>

          {enseignant.grade && (
            <div className="text-gray-600">
              <span className="font-medium">Grade:</span> {enseignant.grade}
            </div>
          )}

          <div className="pt-4">
            <span className={`inline-flex px-3 py-1 text-sm font-semibold rounded-full ${
              enseignant.statut === 'ACTIF' ? 'bg-green-100 text-green-800' :
              enseignant.statut === 'INACTIF' ? 'bg-red-100 text-red-800' :
              'bg-gray-100 text-gray-800'
            }`}>
              {enseignant.statut}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnseignantExterneDetails; 